// extracted by mini-css-extract-plugin
export default {"container":"PauboxStatus_container__2XXug","question":"PauboxStatus_question__luEi9"};